import {
    getAllTagGroupsAction,
    deleteTagGroupById,
    getTagGroupByIdAction,
    updateTagGroupAction,
    createTagGroupAction
} from "../api/actions/TagGroupActions";
import {
    TAG_GROUP_DISPLAY_BAR_LOADING,
    TAG_GROUP_DISPLAY_BAR_SHOW,
    TAG_GROUP_DISPLAY_BAR_ERROR,
    TAG_GROUP_CRUD_FORM_LOADING,
    TAG_GROUP_CRUD_FORM_EDIT,
    TAG_GROUP_CRUD_FORM_ERROR,
    TAG_GROUP_CRUD_FORM_CANCEL,
    TAG_GROUP_CRUD_FORM_CREATE,
    TAG_GROUP_CRUD_FORM_DELETE,
    TAG_GROUP_DISPLAY_BAR_DELETED
} from "./actions/TagGroupActions";
import store from "../redux/Store";
import { getAllTagGroupAndTagsAction, storeAllTagGroupsAction } from "../api/actions/actions";

export const fetchAllTagGroupsAndTagsEvent = (force) => {

    let tagGroups = store.getState().base.tagGroups;

    store.dispatch(getAllTagGroupAndTagsAction())
        .unwrap()
        .then((result) => {
            store.dispatch(storeAllTagGroupsAction(result.content));
        })
        .catch(error => {
            console.error('fetchAllTagGroupsAndTagsEvent', error);
        });

};
export const updateTagGroupDetailsByIdEvent = (tagGroup) => {
    return async (dispatch, state) => {

        if (typeof state.tagGroups != 'object') {
            state.tagGroups = {};
        }

        let group = state.tagGroups[tagGroup.id] || {};
        group.visibility = group.visibility || false;
        group.data = tagGroup;
        group.state = "DONE";
        state.tagGroups[tagGroup.id] = group;

        dispatch(TAG_GROUP_DISPLAY_BAR_SHOW(state.tagGroups));
    }
};
export const updateTagGroupDetailsById = (state, tagGroup) => {

    if (typeof state.tagGroups != 'object') {
        state.tagGroups = {};
    }

    let group = state.tagGroups[tagGroup.id] || {};
    group.visibility = group.visibility || false;
    group.data = tagGroup;
    group.state = "DONE";
    state.tagGroups[tagGroup.id] = group;

    return state.tagGroups;
};
export const viewTagGroupDetailsByIdEvent = (e, id) => {
    return async (dispatch, state) => {

        if (typeof state.tagGroups != 'object') {
            state.tagGroups = {};
        }

        var tagGroups = state.tagGroups[id];

        if (tagGroups && tagGroups.state !== 'ERROR') {
            tagGroups.visibility = !tagGroups.visibility;
            dispatch(TAG_GROUP_DISPLAY_BAR_SHOW(state.tagGroups));
            return;
        }

        state.tagGroups[id] = {
            visibility: true,
            data: null,
            state: "LOADING"
        };

        dispatch(TAG_GROUP_DISPLAY_BAR_LOADING(state.tagGroups));

        getTagGroupByIdAction(id)
            .then((result) => {
                //console.log();
                if (result.content && result.content.id > 0) {
                    state.tagGroups[id] = {
                        visibility: true,
                        data: result.content,
                        state: "DONE"
                    };
                    dispatch(TAG_GROUP_DISPLAY_BAR_SHOW(state.tagGroups));
                }

            }).catch((error) => {
                state.tagGroups[id] = {
                    visibility: false,
                    data: error,
                    state: "ERROR",
                    error: true
                };
                dispatch(TAG_GROUP_DISPLAY_BAR_ERROR(state.discounts));
            });
        //console.log('viewTagGroupDetailsByIdEvent', state);
    }
};
export const editTagGroupEvent = (e, id) => {
    return async (dispatch) => {

        dispatch(TAG_GROUP_CRUD_FORM_LOADING);

        getTagGroupByIdAction(id)
            .then((result) => {
                dispatch(TAG_GROUP_CRUD_FORM_EDIT(result.content));
            }).catch((error) => {
                dispatch(TAG_GROUP_CRUD_FORM_ERROR(error));
            });
    };
};
export const cancelTagGroupCrudFromEvent = (e) => {
    return async (dispatch) => {
        dispatch(TAG_GROUP_CRUD_FORM_CANCEL());
    };
};
const idValueRegex = /([0-9]+)\-([\w\s]+)/i;
const tagsToKeyValue = (array) => {
    return Array.isArray(array) ? array.reduce((a, c) => {
        const match = idValueRegex.exec(c);
        if (match) {
            //a.push({ ]: match[2] });
            a[match[1]] = match[2];
        }
        return a;
    }, {}) : [];
}
export const createTagGroupCrudFromEvent = (e) => {
    return async (dispatch) => {
        dispatch(TAG_GROUP_CRUD_FORM_CREATE());
    };
};
export const saveTagGroupEvent = (json, reduxDispatch, tagGroups) => {
    return async (dispatch, state) => {

        json['tags'] = tagsToKeyValue(json.tags);

        if (json.id > 0) {
            updateTagGroupAction(json)
                .then((result) => {
                    let tagGroup = result?.content;
                    if (tagGroup.id > 0) {
                        //console.log('update tag group', tagGroup);
                        tagGroups.forEach((group, index) => {
                            if (group.id == tagGroup.id) {
                                group.name = tagGroup.name;
                                group.description = tagGroup.description;
                                group.color = tagGroup.color;
                            }
                        });
                        dispatch(TAG_GROUP_DISPLAY_BAR_SHOW(updateTagGroupDetailsById(state, tagGroup)));
                        dispatch(TAG_GROUP_CRUD_FORM_CANCEL());
                    }
                })
                .catch(error => {
                    console.log('CreateTagGroup error', error);
                });
        } else {
            createTagGroupAction(json)
                .then((result) => {
                    let tagGroup = result.content;
                    if (tagGroup.id > 0) {
                        //console.log('create tag group', tagGroup);
                        let group = {
                            id: tagGroup.id,
                            name: json.name,
                            description: json.description,
                            color: json.color
                        };
                        reduxDispatch(storeAllTagGroupsAction([...tagGroups, group]));
                        dispatch(TAG_GROUP_CRUD_FORM_CANCEL());
                    }
                })
                .catch(error => {
                    console.log('CreateTagGroup error', error);
                });
        }

        return;

    };
};
export const getDeleteTagGroupEvent = (e, id) => {
    return async (dispatch) => {
        dispatch(TAG_GROUP_CRUD_FORM_LOADING);

        getTagGroupByIdAction(id)
            .then((result) => {
                dispatch(TAG_GROUP_CRUD_FORM_DELETE(result.content));
            }).catch((error) => {
                dispatch(TAG_GROUP_CRUD_FORM_ERROR(error));
            });
    };
};

export const deleteTagGroupEvent = (json) => {
    return async (dispatch, state) => {
        if (json.id > 0) {
            if (typeof state.tagGroups != 'object') {
                state.tagGroups = {};
            }
            deleteTagGroupById(json)
                .then(result => {
                    state.tagGroups[json.id] = {
                        [result.content > 0 ? 'deleted' : 'error']: true,
                        data: null
                    };
                    dispatch(TAG_GROUP_DISPLAY_BAR_DELETED(state.tagGroups));
                    dispatch(TAG_GROUP_CRUD_FORM_CANCEL());
                })
                .catch(error => {
                    dispatch(TAG_GROUP_CRUD_FORM_CANCEL(error));
                });
        }
    };
};